import { customBaseQuery } from '@/lib/baseQuery';
import { createApi } from '@reduxjs/toolkit/query/react';

export const quickLinksApi = createApi({
  reducerPath: 'quickLinksApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    createQuickLink: builder.mutation<any, any>({
      query: (data) => ({
        url: '/quick-links',
        method: 'POST',
        body: data,
      }),
    }),
    getQuickLinks: builder.query<any, void>({
      query: () => ({
        url: '/quick-links',
      }),
    }),
    createQuickLinksBulk: builder.mutation<any, any>({
      query: (data) => ({
        url: '/quick-links-bulk',
        method: 'POST',
        body: data,
      }),
    }),
    getAllQuickLinks: builder.query<any, void>({
      query: () => ({
        url: '/quick-links',
      }),
    }),
    deleteQuickLink: builder.mutation<any, any>({
      query: (id) => ({
        url: `/quick-links/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetQuickLinksQuery,
  useCreateQuickLinkMutation,
  useCreateQuickLinksBulkMutation,
  useDeleteQuickLinkMutation,
  useGetAllQuickLinksQuery,
} = quickLinksApi;
